import { CartErrorEvent, CartLinesUpdateEvent } from '@shopify/events';

class GroveBestsellers extends HTMLElement {
  connectedCallback() {
    const mode = document.documentElement.getAttribute('data-grove-bestsellers-mode');
    if (mode === 'bestselling' || mode === 'stock') {
      this.dataset.mode = mode;
    }
    this.addEventListener('click', this.#handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
  }

  #handleClick = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const button = target.closest('[data-grove-bestseller-add]');
    if (!(button instanceof HTMLButtonElement) || button.disabled) return;
    this.#addToCart(button);
  };

  async #addToCart(button) {
    const variantId = button.dataset.variantId;
    const productId = button.dataset.productId;
    const label = button.querySelector('[data-grove-bestseller-label]');
    const message = this.querySelector('[data-grove-bestseller-message]');
    if (!variantId || !(label instanceof HTMLElement)) return;

    const originalLabel = label.textContent;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    label.textContent = 'Adding…';
    if (message instanceof HTMLElement) message.textContent = '';

    const sectionIds = Array.from(document.querySelectorAll('cart-items-component'))
      .map((component) => (component instanceof HTMLElement ? component.dataset.sectionId : null))
      .filter(Boolean);
    const deferredEventPromise = CartLinesUpdateEvent.createPromise();

    this.dispatchEvent(
      new CartLinesUpdateEvent({
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: variantId, quantity: 1 }],
        promise: deferredEventPromise.promise,
      })
    );

    try {
      const response = await fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: Number(variantId), quantity: 1 }],
          sections: sectionIds.join(','),
          sections_url: window.location.pathname,
        }),
      });
      const result = await response.json();

      if (!response.ok || result.status) {
        const errorMessage = result.description || result.message || 'Could not add this item.';
        this.dispatchEvent(
          new CartErrorEvent({
            error: errorMessage,
            code: 'INVALID',
            detail: { description: errorMessage },
          })
        );
        deferredEventPromise.reject(new Error(errorMessage));
        throw new Error(errorMessage);
      }

      const cartResponse = await fetch(`${Theme.routes.cart_url}.js`, {
        headers: { Accept: 'application/json' },
      });
      if (!cartResponse.ok) throw new Error('Could not refresh the cart.');
      const cart = await cartResponse.json();

      deferredEventPromise.resolve({
        cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
        detail: {
          items: cart.items,
          sections: result.sections,
          source: 'grove-bestsellers',
          sourceId: this.dataset.context || 'bestsellers',
          itemCount: 1,
          productId,
          didError: false,
        },
      });

      label.textContent = 'Added';
      if (message instanceof HTMLElement) {
        message.textContent = 'Added to cart.';
      }
    } catch (error) {
      console.error(error);
      if (label.isConnected) label.textContent = originalLabel || '+ Add';
      if (button.isConnected) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }
      if (message instanceof HTMLElement && message.isConnected) {
        message.textContent = error instanceof Error ? error.message : 'Could not add this item.';
      }
    }
  }
}

if (!customElements.get('grove-bestsellers')) {
  customElements.define('grove-bestsellers', GroveBestsellers);
}
